/**
 * TypeScript Constructor Serialization Module
 * 
 * Exports TypeScript constructor serializer for generating code
 */

export {
  TypeScriptConstructorSerializer,
  type TypeScriptConstructorSerializationConfig,
  DEFAULT_TYPESCRIPT_CONSTRUCTOR_CONFIG,
} from './typescript_constructor_serializer.ts';
